import styled from "styled-components";

import { Instructions } from "../instructions";

export const BlueText = styled(Instructions)`
  color: ${({ theme }) => theme.colours.textBlue};
  font-weight: normal;
`;
